import type { SupportedCountryIso2 } from './countries';

// E.164 validation pattern per supported country.
// Add a country → add its ISO2 to countries.ts and its pattern here.
export const PHONE_REGEX_BY_ISO2: Record<SupportedCountryIso2, RegExp> = {
  ua: /^\+380\d{9}$/, // +380 followed by 9 digits
  us: /^\+1\d{10}$/, // +1 followed by 10 digits
};
